import https from "@/lib/https";
import { getAuthMeApi } from "@/pages/auth/api/auth.api";
import type { ProfileDetail } from "@/interface/auth";
import type {
  ProfilePayload,
  ProfileCompletionData,
} from "@/interface/profile";
import type { ApiResponse } from "@/interface/common";

const BASE_URL = "/api/profiles/";

export const getProfileDetail = async (): Promise<
  ApiResponse<ProfileDetail>
> => {
  return await getAuthMeApi();
};

export const getProfileCompletion = async (
  id: number | string,
): Promise<ApiResponse<ProfileCompletionData>> => {
  return await https.get<ApiResponse<ProfileCompletionData>>(
    `/api/profile-completion/${id}/`,
  );
};

export const updateProfile = async (
  id: number | string,
  payload: ProfilePayload,
): Promise<ApiResponse<ProfileDetail>> => {
  return await https.put<ApiResponse<ProfileDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const patchProfile = async (
  id: number | string,
  payload: Partial<ProfilePayload> | FormData,
): Promise<ApiResponse<ProfileDetail>> => {
  return await https.patch<ApiResponse<ProfileDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};
